import { Link, useLocation } from "react-router-dom";
import { Fuel, Users } from "lucide-react";

const tabs = [
  { href: "/gas-stations", label: "Station network", icon: Fuel },
  { href: "/fuel-activity", label: "User activity", icon: Users },
] as const;

export function FuelMenuNav() {
  const { pathname } = useLocation();

  return (
    <nav className="flex flex-wrap gap-2" aria-label="Fuel menu">
      {tabs.map(({ href, label, icon: Icon }) => {
        const active =
          href === "/fuel-activity" ? pathname.startsWith("/fuel-activity") : pathname.startsWith(href);
        return (
          <Link
            key={href}
            to={href}
            className={
              active
                ? "inline-flex items-center gap-2 rounded-full bg-foreground px-4 py-2 text-sm font-semibold text-surface transition"
                : "inline-flex items-center gap-2 rounded-full bg-canvas px-4 py-2 text-sm font-semibold text-muted transition hover:bg-canvas-hover hover:text-foreground"
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
